export default {
    install(Vue) {
        Vue.prototype.$numberFormat = function (number, decimals = 2) {
            return new Intl.NumberFormat("th-TH", {
                minimumFractionDigits: decimals,
            }).format(number);
        };

        Vue.prototype.$quantityFormat = function (number) {
            return new Intl.NumberFormat("th-TH").format(number);
        };

        Vue.prototype.$priceFormat = function (
            number,
            decimals = 2,
            currency = "THB"
        ) {
            const formatter = new Intl.NumberFormat("th-TH", {
                style: "currency",
                currency: currency,
                minimumFractionDigits: decimals,
            });

            return formatter.format(number);
        };

        Vue.prototype.$emailValidate = function (email) {
            const re = /\S+@\S+\.\S+/;
            return re.test(email);
        };

        Vue.prototype.$dateFormat = function (date) {
            // pattern = d/m/yyyy hh:mm
            const [datePart, timePart] = date.split(" ");
            const [year, month, day] = datePart.split("-");
            const [hour, minute] = timePart.split(":");

            return `${day}/${month}/${year} ${hour}:${minute}`;
        };
    },
};
